import Vue from "vue";
import VueRouter from "vue-router";

// routes for different sections
import HomeRoutes from "../../sections/home/router";
import ProjectsRoutes from "../../sections/projects/router";
import ArticlesRoutes from "../../sections/articles/router";
import ContactRoutes from "../../sections/contact/router";
import ImpressRoutes from "../../sections/impress/router";
// import AdminRoutes from "../admin/router/";

// routes array for router instantiation
const routes = [].concat([
  ...HomeRoutes,
  ...ProjectsRoutes,
  ...ArticlesRoutes,
  ...ContactRoutes,
  ...ImpressRoutes
]);

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo({
    // behavior: "smooth",
    top: 0
  });
  next();
});

export default router;
